import React from 'react';

const Landing = () => {
    return (
        <div className='pt-40 py-4'>
            <div className='w-11/12 mx-auto text-center'>
                <h1 className='text-2xl lg:text-3xl'>Now talk to your friends in   <span className='text-blue-900 font-medium' > React Chat App</span></h1>
                <h2 className='py-3 text-lg'>Login and start Chatting</h2>
            </div>

        </div>
    );
};

export default Landing;